import React from 'react';
import './Indicator.css';
import { List, ListItem } from '@material-ui/core';
import { Markup } from 'interweave';
import IndicatorTable from 'components/IndicatorTable/IndicatorTable';
import translations from 'data/translations.json';

class Indicator extends React.Component {
    componentDidMount() {
        /*
        import(`data/${this.props.id}.json`).then(({ default: jsonData }) => {
            console.log("Data:", jsonData);
            this.setState({ data: jsonData });
        });
        */
    }

    render() {
        const info = this.props.info;

        return (
            <div className="indicator">
                <h2 className="indicator-title">{translations[info.title][window.lang]}</h2>
                <div className="indicator-table-container">
                    <IndicatorTable source={translations.source[window.lang] + ": " + translations[info.source][window.lang]} schema={info.schema} data={info.data} code={info.code} title={info.title} />
                </div>
                <div className="indicator-annotation">
                    <h4>{translations.annotations[window.lang]}</h4>
                    <List className="indicator-annotation-container" dense={true} disablePadding={true}>
                        {
                            info.annotations[window.lang].map((annotation, index) => (
                                <ListItem key={index}>
                                    <Markup content={annotation} />
                                </ListItem>)
                            )
                        }
                    </List>
                </div>
            </div>
        );
    }
}

export default Indicator;